import client from "apis/config";

export const getCompanyInfoApi = async () => {
  return await client.get(`companyInfo`);
};

export const updateCompanyInfoApi = async (data) => {
  return await client.patch(`companyInfo`, data);
};
